import { render, staticRenderFns } from "./LightControl.vue?vue&type=template&id=03a984bc&scoped=true"
import script from "./LightControl.vue?vue&type=script&lang=js"
export * from "./LightControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a984bc",
  null
  
)

export default component.exports